module.exports = __webpack_public_path__ + "static/img/128.0f472d7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/128.png
// module id = 4jFl
// module chunks = 0